import React from "react";
import TextLoop from "react-text-loop";

const conctInfo = {
  phone: "33 1765 8536",
  email: "ventas@activodigitalmx.com",
};

const sliderContent = {
  name: "Activo Digital",
  designation: "Expertos en Infraestructura Cloud y Transformación Digital",
  description: `No solo creamos páginas; construimos ecosistemas digitales. Potenciamos tu negocio con la escalabilidad de Google Cloud Platform y soluciones de TI diseñadas para emprendedores y empresas en crecimiento.`,
  btnText: "Cotizar Proyecto",
};

const Slider = () => {
  return (
    <>
      {/*  Home Banner */}
      <section id="inicio" className="home-banner">
        <div className="hb-top-fixed d-flex">
          <div className="hb-info">
            <a href="https://wa.me/523317658536" target="_blank" rel="noreferrer">{conctInfo.phone}</a>
            <a href="mailto:ventas@activodigitalmx.com">
              {conctInfo.email}
            </a>
          </div>
        </div>
        {/* End hp-top-fixed */}

        <div className="container">
          <div className="row full-screen align-items-center">
            <div className="col-lg-7">
              <div className="type-box">

                <h1
                  className="font-alt"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="100"
                >
                  Activo <span style={{ color: "#FF56DF", filter: "brightness(1.1) contrast(1.1) saturate(1.3)" }}>Digital</span>
                </h1>
                <div
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="200"
                >
                  <TextLoop interval={5000}>
                    <p className="loop-text lead" style={{ color: "#81C04B", filter: "brightness(1.1) contrast(1.1) saturate(1.3)" }}>Expertos en Google Cloud</p>
                    <p className="loop-text lead" style={{ color: "#F2B155", filter: "brightness(1.1) contrast(1.1) saturate(1.3)" }}>Desarrollo Web & Ecommerce</p>
                    <p className="loop-text lead" style={{ color: "#E54D4C", filter: "brightness(1.1) contrast(1.1) saturate(1.3)" }}>Infraestructura Tecnológica</p>
                    <p className="loop-text lead" style={{ color: "#A858C4", filter: "brightness(1.1) contrast(1.1) saturate(1.3)" }}>Soporte Técnico Especializado</p>
                    <p className="loop-text lead" style={{ color: "#4F91CE", filter: "brightness(1.1) contrast(1.1) saturate(1.3)" }}>Consultores en Google Workspace</p>
                  </TextLoop>
                </div>
                <p
                  className="desc"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="600"
                >
                  {sliderContent.description}
                </p>
                <div
                  className="mt-4"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                  data-aos-delay="700"
                >
                  <a
                    className="px-btn px-btn-white-green"
                    href="https://wa.me/523317658536"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {sliderContent.btnText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Container*/}


        <div
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
          className="hb-me-wrapper"
        >
          <div
            className="hb-me"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL + "img/slider/home-banner.png"
                })`,
            }}
          ></div>
        </div>
      </section>
      {/* End Home Banner  */}
    </>
  );
};

export default Slider;
